// start:ng42.barrel
import './colour.service';
import './components';
// end:ng42.barrel

